import {FC} from 'react'
import { toAbsoluteUrl} from '../../../../_metronic/helpers'
const Error403: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Forbidden</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        You do not have permission to access this data <br /> please contact our administrator
      </div>
      <div className="mb-11">
          <img src={toAbsoluteUrl('/media/auth/Forbidden.png')} className="mw-100 mh-300px theme-light-show" alt="Forbidden"/>
          
      </div>
    </>
  )
}

export {Error403}
